import { TextField, YStack } from '@shinetools/lumen-react'
import { useTranslation } from 'react-i18next'

// The @components barrel re-exports CreateContactModal, which renders this section through the create-supplier modal.
// Moving the supplier modal out of views/ does not fix this; it can import from @components again once the barrel
// stops re-exporting CreateContactModal and ContactSelect (EXP-660).
// eslint-disable-next-line @billy/shine-accounting/consistent-alias-imports -- importing the barrel from here cycles back through CreateContactModal
import { CountryDropdown } from '../../../../../../../../../../../../components/selects/CountryDropdown/CountryDropdown'
import { DesignSystem } from '../../../../../../../../../../../../enums/designSystem'
import { useFormContext } from '../../../../../../../../../../../../hooks/useForm'
import type { WithTrackingContext } from '../../../../../../../../../../../../types/withTrackingContext'
import type { SupplierFormSchema } from '../../../../types/supplierForm'
import { AdditionalContact } from '../AdditionalContact'
import { AutomationSection } from '../AutomationSection'

export const ManageIndividual = ({ trackingContext }: WithTrackingContext) => {
  const { t } = useTranslation()
  const { FormItem } = useFormContext<SupplierFormSchema, DesignSystem.Lumen>({ designSystem: DesignSystem.Lumen })

  return (
    <YStack gap={32}>
      <YStack gap={24}>
        <FormItem
          name="firstName"
          render={({ error, field }) => (
            <TextField
              {...field}
              error={error}
              label={t('suppliers.detail.form.first_name.label')}
              placeholder={t('suppliers.detail.form.name.placeholder')}
              size="small"
            />
          )}
        />
        <FormItem
          name="lastName"
          render={({ error, field }) => (
            <TextField
              {...field}
              error={error}
              label={t('suppliers.detail.form.last_name.label')}
              placeholder={t('suppliers.detail.form.name.placeholder')}
              size="small"
            />
          )}
        />
        <FormItem
          name="countryId"
          render={({ error, field }) => (
            <CountryDropdown
              countryId={field.value}
              error={error}
              label={t('suppliers.detail.form.country.label')}
              onSelect={field.onChange}
            />
          )}
        />
        <FormItem
          name="phone"
          render={({ error, field }) => (
            <TextField
              {...field}
              error={error}
              label={t('suppliers.detail.form.phone.label')}
              placeholder={t('suppliers.detail.form.phone.placeholder')}
              size="small"
              type="tel"
            />
          )}
        />
        <FormItem
          name="street"
          render={({ error, field }) => (
            <TextField {...field} error={error} label={t('suppliers.detail.form.address.label')} size="small" />
          )}
        />
        <FormItem
          name="email"
          render={({ error, field }) => (
            <TextField
              {...field}
              error={error}
              label={t('suppliers.detail.form.email.label')}
              placeholder={t('suppliers.detail.form.email.placeholder')}
              size="small"
              type="email"
            />
          )}
        />
      </YStack>
      <AdditionalContact />
      <AutomationSection trackingContext={trackingContext} />
    </YStack>
  )
}
